import { Layout } from 'antd';
import classNames from 'classnames';
import { SIDER_WIDTH } from '../../../constants/layout';
import { CustomLayoutProps } from '../../../interfaces';
import { DefaultLayoutWrapper } from './styles';
import './styles.scss';

const { Sider, Content } = Layout;

const DefaultLayout: React.FC<CustomLayoutProps> = props => {
  const { children, sider, header, className, ...rest } = props;

  return (
    <DefaultLayoutWrapper
      {...rest}
      className={classNames(className, 'default-layout')}
    >
      <Sider id="test" width={SIDER_WIDTH} breakpoint="xl">
        {sider}
      </Sider>
      <Content>{children}</Content>
    </DefaultLayoutWrapper>
  );
};

export default DefaultLayout;
